import { css } from 'linaria';

export const inListButton = css`
  --button-hover-color: var(--control-hover-secondary) !important;
`;

export const inListButtonActive = css`
  --button-color: var(--brand-primary) !important;
  --button-hover-color: var(--control-hover-secondary) !important;
`;
